module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// ./~/react-share/~/core-js/library/modules/_iter-step.js
// module id = 2001
// module chunks = 2